"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paginate = paginate;
const LEFT_LIMIT_OF_PAGE_RANGE = 1;

function getCurrentPage(current, total) {
  if (current < LEFT_LIMIT_OF_PAGE_RANGE) {
    return LEFT_LIMIT_OF_PAGE_RANGE;
  } else if (current > total) {
    return total;
  }

  return current;
}

function getPaginationRange(page, total, limit) {
  // total pages less than max so show all pages
  if (total <= limit) {
    return {
      start: 1,
      end: total
    };
  } // total pages more than max so calculate start and end pages


  const maxPagesBeforeCurrentPage = Math.floor(limit / 2);
  const maxPagesAfterCurrentPage = Math.ceil(limit / 2) - 1; // current page near the start

  if (page <= maxPagesBeforeCurrentPage) {
    return {
      start: LEFT_LIMIT_OF_PAGE_RANGE,
      end: limit
    };
  } // current page near the end


  if (page + maxPagesAfterCurrentPage >= total) {
    return {
      start: total - limit + 1,
      end: total
    };
  } // current page somewhere in the middle


  return {
    start: page - maxPagesBeforeCurrentPage,
    end: page + maxPagesAfterCurrentPage
  };
}

function buildPageList(start, end) {
  const arrayLength = new Array(end + 1 - start);
  const emptyArray = arrayLength.fill(undefined);
  return emptyArray.map((_, index) => start + index);
}

function paginate(current, total, limit) {
  const page = getCurrentPage(current);
  const {
    start,
    end
  } = getPaginationRange(page, total, limit);
  return buildPageList(start, end);
}